<template>
  <div>
    <ft-navbar></ft-navbar>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Zierstäbe <span class="text-muted">({{filtered.length}}/{{zierstaebe.length}})</span>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ul>
              <li>Zierstäbe werden meist in Kombination mit Eckgesimsen und / oder Deckenstäben verwendet.</li>
              <li>Mit zierstäben können Wandkassetten erstellt werden.</li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Auf Wunsch werden auch Massanfertigungen hergestellt.</li>
            </ul>
          </div>
        </div>
        <div class="row my-5">
          <b-form inline>
            <b-form-select class="mb-2 mr-sm-4 mb-sm-1" v-model="type" :options="types"/>
            <b-form-input type="text" placeholder="Nummer (z.B. 1002)" v-model="mnumber"></b-form-input>
          </b-form>
        </div>
        <div class="row">
          <grid min="240px" v-if="filtered.length">
            <div class="scard" v-for="spec in filtered" :key="spec.model">
              <div v-if="spec.thumbnail" @click="showDetail(spec)" class="scard-img-cnt">
                <b-img-lazy :src="spec.thumbnail" blank-width="200" blank-height="200" blank-color="#212529"
                            :alt="title(spec)"
                            class="scard-img-top img-fluid"/>
              </div>
              <div class="scard-body">
                <h4 class="scard-title">{{title(spec)}}</h4>
                <ul class="list-unstyled">
                  <li v-html="spec.description"></li>
                </ul>
              </div>
            </div>
          </grid>
          <div class="m-auto" v-else>
            <spinner></spinner>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="detailModalRef" hide-footer centered size="lg">
      <spinner v-if="imgLoading"></spinner>
      <b-img fluid :src="detailImage" @load="imgLoaded"/>
    </b-modal>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'
import Spinner from '@/components/Spinner'
import axios from 'axios'

export default {
  name: 'Zierstaebe',
  components: {ftNavbar, Grid, Spinner},
  data () {
    return {
      zierstaebe: [],
      type: '-',
      mnumber: null,
      detailImage: null,
      imgLoading: true,
      types: [
        {value: '-', text: 'Alle Typen'},
        {value: 'B', text: 'Blattstab'},
        {value: 'E', text: 'Eierstab'},
        {value: 'PS', text: 'Perlschnur'},
        {value: 'Z', text: 'Zahnstab'},
        {value: 'M', text: 'Weitere'}
      ]
    }
  },
  computed: {
    filtered () {
      let filtered = this.zierstaebe

      if (this.mnumber) {
        return filtered.filter(m => ('' + m.model).indexOf('' + this.mnumber) === 0)
      }

      if (this.type !== '-') {
        filtered = filtered.filter(r => r.type === this.type)
      }
      return filtered
    }
  },

  methods: {
    title (obj) {
      if (obj.type === 'PS') {
        return `PS${obj.model}`
      }
      return `Z${obj.model}`
    },
    mapStyle (style) {
      return this.styles.filter(s => s.value === style).map(s => s.text)
    },
    niceStyles (styles) {
      const qq = styles.map(style => this.mapStyle(style)).filter(style => style)
      return qq.join(', ')
    },
    showDetail (r) {
      if (this.detailImage !== r.detail) {
        this.detailImage = ''
        this.imgLoading = true
        this.detailImage = r.detail
      }
      this.$refs.detailModalRef.show()
    },
    imgLoaded () {
      this.imgLoading = false
    }
  },
  mounted () {
    axios.get(`${this.$api}/zierstaebe/list/`)
      .then(response => {
        this.zierstaebe = response.data.models
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Zierstaebe.vue